import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import { useSelector } from "react-redux";
import {
  getRightContent,
  getVisibleSensorAnimation,
} from "../../assets/js/utils";
import Accordion from "../Accordion";
import StaticTable from "../StaticTable";
import content from "../../assets/content/content.json";
import TitleParagraphs from "../TitleParagraphs";

function Section5(props) {
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <>
      <h1 className="section5-header general-lp general-rp">
        {getRightContent(
          generalSettings.rtlLanguage,
          content.sections[sections.currentSection].content.title
        )}
      </h1>
      <Accordion
        items={[
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[0],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  redBottomBorder={true}
                  coloredColumnsBackgrounds={
                    content.sections[sections.currentSection].content
                      .table1Consolidate.coloredColumnsBackgrounds
                  }
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table1Consolidate.title
                  )}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table1Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table1Consolidate.contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[1],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  coloredColumnsBackgrounds={
                    content.sections[sections.currentSection].content
                      .table2Consolidate.coloredColumnsBackgrounds
                  }
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table2Consolidate.title
                  )}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table2Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table2Consolidate.contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[2],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  redBottomBorder={true}
                  coloredColumnsBackgrounds={
                    content.sections[sections.currentSection].content
                      .table3Consolidate.coloredColumnsBackgrounds
                  }
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table3Consolidate.title
                  )}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table3Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table3Consolidate.contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[3],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  firstColumnWider={true}
                  redBottomBorder={true}
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table4_1Consolidate.title
                  )}
                  coloredColumnsBackgrounds={
                    content.sections[sections.currentSection].content
                      .table4_1Consolidate.coloredColumnsBackgrounds
                  }
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table4_1Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table4_1Consolidate.contentRows
                  )}
                />

                <StaticTable
                  firstColumnWider={true}
                  redBottomBorder={true}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table4_2Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table4_2Consolidate.contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[4],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  coloredColumnsBackgrounds={
                    content.sections[sections.currentSection].content
                      .table5Consolidate.coloredColumnsBackgrounds
                  }
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table5Consolidate.title
                  )}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table5Consolidate.header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .table5Consolidate.contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[5],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  redBottomBorder={true}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table1
                      .header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table1
                      .contentRows
                  )}
                />

                <StaticTable
                  redBottomBorder={true}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table2
                      .header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table2
                      .contentRows
                  )}
                />
              </div>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[6],
            content: (
              <>
                <div className="general-m">
                  <TitleParagraphs
                    items={getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .titleParagraphs
                    )}
                  />
                </div>
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <h3
                      className="section5__roman-list general-m-just-small-screen"
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 2s")}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .romanList
                        )[0]
                      }
                    </h3>
                  )}
                </VisibilitySensor>
                <div className="vertical-separator">
                  <StaticTable
                    redBottomBorder={true}
                    header={getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.table3
                        .header
                    )}
                    contentsRow={getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.table3
                        .contentRows
                    )}
                  />

                  <StaticTable
                    redBottomBorder={true}
                    header={getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.table4
                        .header
                    )}
                    contentsRow={getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.table4
                        .contentRows
                    )}
                  />
                </div>
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <div
                      className="general-m-just-small-screen"
                      style={getVisibleSensorAnimation(
                        isVisible,
                        "fadeIn 1s backwards"
                      )}
                    >
                      <p className="table-bottom-label">
                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .tableBottomLabel
                        )}
                      </p>
                      <p className="table-bottom-legend">
                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .tableBottomLegend
                        )}
                      </p>
                    </div>
                  )}
                </VisibilitySensor>
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <h3
                      className="section5__roman-list general-m-just-small-screen"
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 2s")}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .romanList
                        )[1]
                      }
                    </h3>
                  )}
                </VisibilitySensor>
                <StaticTable
                  redBottomBorder={true}
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table5
                      .header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table5
                      .contentRows
                  )}
                />
              </>
            ),
          },
          {
            title: getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.accordionTitles
            )[7],
            content: (
              <div className="vertical-separator">
                <StaticTable
                  header={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table6
                      .header
                  )}
                  contentsRow={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.table6
                      .contentRows
                  )}
                />
              </div>
            ),
          },
        ]}
      />
    </>
  );
}

export default Section5;
